const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const RecuperatingCondition = require('../../conditions/RecuperatingCondition');
const { logError } = require('../../logger');

const Sanctuary = function (battleState) {
  this.handle = 'sanctuary';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return true;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      var recuperatingConditions = [];

      for (var uid in battleState.allUnits) {
        var unit = battleState.allUnits[uid];
        if (
          unit.inPlay &&
          unit.team === actor.team &&
          BattleCalc.boardDistance(unit, victim) <= ability.effectRange
        ) {
          const recuperating = new RecuperatingCondition(
            actor,
            unit,
            battleState,
            ability.healing,
            ability.duration
          );
          battleState.onUnitCondition(recuperating);
          recuperatingConditions.push(recuperating);
        }
      }

      this.eventEmitter.emit('result', {
        abilityHandle: this.handle,
        actorId: actor.uid,
        victimId: victim.uid,
        recuperatingConditions,
        effectRange: ability.effectRange,
        allPieces: battleState.allPieces,
      });
    } catch (err) {
      logError(err, {
        module: 'Sanctuary',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = Sanctuary;
